import React from "react";
import "./Footer.css";

const Footer = () => {
    return (
        <>
            <div >
                <div className="footer">
                    <p>Copyright © | 2021</p>
                </div>
            </div>

        </>
    )
}

export default Footer;